
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import {
    DialogAlert,
    IfComp,
    ToolbarCommandButton
} from '../../../core';

import { useDisableEditMsg } from '../../../project';

import Document from './Document';
import DialogDocumentLink from './DialogDocumentLink';

const DocumentList = ({
    dataActions,
    documentList,
    objectKey,
    projectId,
    readOnly,
    token
}) => {

    const disableEditMsg = useDisableEditMsg();

    const handleAdd = async () => {
        if (!disableEditMsg) {
            let res = await DialogDocumentLink.show('', '', '');
            if (res) {
                dataActions.insertDocument(
                    token, projectId,
                    {
                        objectKey,
                        url: res.url,
                        title: res.title,
                        description: res.description
                    }
                );
            }
        } else {
            DialogAlert.show(disableEditMsg);
        }
    }

    return (
        <Stack>
            <IfComp cond={(documentList.length === 0)}>
                Nejsou připojeny žádné odkazy na dokumenty
            </IfComp>
            <IfComp cond={(documentList.length > 0)}>
                {documentList.map(item => {
                    return (
                        <Document
                            dataActions={dataActions}
                            item={item}
                            key={item.gid}
                            projectId={projectId}
                            readOnly={readOnly}
                            token={token}
                        />
                    )
                })}
            </IfComp>
            <IfComp cond={!readOnly}>
                <Stack.Item align="end">
                    <ToolbarCommandButton items={[
                        {
                            text: 'Přidat',
                            title: 'Přidat nový odkaz na dokument',
                            onClick: handleAdd
                        }
                    ]}/>
                </Stack.Item>
            </IfComp>
        </Stack>
    );
}

export default DocumentList;
